<template>
  <div class="container-fluid border m-2">
    <div v-show="!root" class="row">
      <button @click="open = !open" class="btn btn-secondary btn-sm">
        <span v-if="!open"><font-awesome-icon icon="plus"/></span>
        <span v-else><font-awesome-icon icon="minus"/></span>
      </button>
    </div>
    <div class="wrapper" v-if="open || root">
      <div class="row" v-for="(val,key) in data" :key="key">
        <div class="col-sm">
          <b>{{ key }}</b>
        </div>
        <div class="col-md">
          <JsonViewer v-if="isObject(val)" :data="isObject(val)"/>
          <ul v-else-if="isArray(val)" class="list-group">
            <li v-for="(e,idx) in JSON.parse(val)" :key="idx" class="list-group-item">
              {{ idx }}
            </li>
          </ul>
          <span v-else>{{ val }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JsonViewer',
  props: {
    data: { type: Object, required: true },
    root: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      open: false
    }
  },
  methods: {
    isObject: function(o) {
      if (o == null || o == undefined) return false;
      if (typeof o == "object") {
        return o;
      }
      if (o.startsWith && o.startsWith('{') && o.endsWith('}')) {
        return JSON.parse(o);
      }
      return false;
    },
    isArray: function(o) {
      console.log('array?')
      if (o == null) return false;
      if (Array.isArray(o)) return true;
      if (o.startsWith && o.startsWith('[') && o.endsWith(']')) {
        console.log('parse array');
        return true;
      }
      return false;
    }
  }
}
</script>
